"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSearch = exports.UserSearchArgs = void 0;
var get_component_1 = require("../../shared/helpers/get-component");
var user_search_form_1 = require("./user-search-form");
exports.UserSearchArgs = {
    onSubmit: console.log,
    inputPlaceholderText: 'Search Text',
};
exports.UserSearch = (0, get_component_1.getComponent)(user_search_form_1.UserSearchForm, exports.UserSearchArgs);
